import Vue from 'vue/dist/vue.esm'

Vue.component("forms-generic-input-vue", () => import(/* webpackChunkName: "[request]" */ "components/forms/GenericInput"))
Vue.component("checkbox-selector-vue", () => import(/* webpackChunkName: "[request]" */ "components/forms/CheckboxSelector"))
Vue.component("hubs-search-vue", () => import(/* webpackChunkName: "[request]" */ "components/hubs/Search"))
Vue.component("hubs-gallery-vue", () => import(/* webpackChunkName: "[request]" */ "components/hubs/Gallery"))
Vue.component("bin-card-wrapper-vue", () => import(/* webpackChunkName: "[request]" */ "components/bin_card/BINCardWrapper"))
Vue.component('sofia-file-uploader-vue', () => import(/* webpackChunkName: "[request]" */ "components/sofia/FileUploader"))
